import React from 'react';
import { useSelector } from 'react-redux';
import { textractLineItemsTableLastColumnMatchedLinesSelector } from '@/domain/textract/selectors';
import { jeMatchedLinesSelector } from '@/domain/journal';
import { Map } from 'immutable';
import { MatchingColorsMap, TwoWayMatchAnchors, TEXTRACT_MATCH_STATUSES } from '@/components/TwoWayMatch/matching';
import {
  displayedTwoWayMatchCell,
  twoWayMatchRowEndPoint,
} from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageTwoWayMatchLayer/twoWayMatchGeometry';
import { TwoWayMatchRowMarker } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageTwoWayMatchLayer/TwoWayMatchRowMarkers/TwoWayMatchRowMarker';
import { rtlEnable } from '@/domain/env';

export const TwoWayMatchRowMarkers = ({ width, height, scale, userRotation, turnFromUpright, page }) => {
  const matchedRowEndCells = useSelector(textractLineItemsTableLastColumnMatchedLinesSelector);
  const fullLinesMapping = useSelector(jeMatchedLinesSelector);
  const rtl = useSelector(rtlEnable);

  return (
    <>
      {matchedRowEndCells &&
        Object.entries(matchedRowEndCells).map(([_jeLineIndex, rowEndCells]) =>
          rowEndCells
            .filter((rowEndCell) => rowEndCell?.page === page)
            .map((rowEndCell) => {
              // if case there is pointer to unexisting line
              if (!rowEndCell) return null;

              const relations = fullLinesMapping
                .filter((jeLine) => jeLine.get(0, new Map()).get('line') === parseInt(rowEndCell.row))
                .flatMap((match, jeLineKey) => ({
                  relation: {
                    targetId: TwoWayMatchAnchors.jeLineElementId(jeLineKey),
                    targetAnchor: !rtl ? 'left' : 'right',
                    sourceAnchor: !rtl ? 'right' : 'left',
                    style: {
                      strokeColor: 'transparent',
                      strokeWidth: 1,
                    },
                  },
                  jeLineKey,
                  color: MatchingColorsMap[match.get(0).get('status', TEXTRACT_MATCH_STATUSES.DEFAULT)],
                }))
                .flatten()
                .toJS();

              const point = twoWayMatchRowEndPoint(
                displayedTwoWayMatchCell(rowEndCell.Geometry.Polygon, userRotation),
                turnFromUpright,
                rtl,
              );
              return Object.keys(relations).length > 0 ? (
                <TwoWayMatchRowMarker
                  key={rowEndCell.id}
                  rowEndCell={rowEndCell}
                  relations={relations}
                  width={width}
                  height={height}
                  point={point}
                  scale={scale}
                />
              ) : null;
            }),
        )}
    </>
  );
};
